const LangHeader = {
	"header.topMenu._benefits": ["BENEFITS", "អត្ថប្រយោជន៍"],
	"header.topMenu._mobile_app": ["MOBILE APP", "កម្មវិធី​ទូរស័ព្ទ"],
	"header.topMenu._view_card_designs": ["VIEW CARD DESIGNS", "មើល​ម៉ូត​កាត"],
	"header.topMenu._faqs": ["FAQS", "ចម្ងល់​ផ្សេង​ៗ"],
	"header.topMenu._login_signup": ["Sign In / Sign Up", "ចូល​គណនី​ / បង្កើត​គណនី"],
}

export default LangHeader



// WEBPACK FOOTER //
// ./src/resources/modules/LangHeader.js